// @flow

export const ACTIONS = {
    OPEN_SUMMARY_DRAWER: 'open-summary-drawer',
    CLOSE_SUMMARY_DRAWER: 'close-summary-drawer',
    LOAD_REACTIONS: 'load-reactions'
};
